import styled from 'styled-components';

const IconButton = styled.button`
    color: currentColor;
    background: transparent;
    border: 0;
    padding: 0;
    cursor: pointer;
    text-align: center;
    display: inline;
    position: relative;
    z-index: 0;
    overflow: visible;

    &:hover,
    &:focus,
    &:active {
        text-decoration: none;
        outline: none;

        &:before {
            content: '';
            display: block;
            position: absolute;
            z-index: -1;
            transform: translate(-50%, -50%);
            top: 50%;
            left: 50%;
            width: 2em;
            height: 2em;
            border-radius: 50%;
        }
    }
`;

export default IconButton;
